// Below this container width a pie with a vertical legend beside it does not
// fit: a shared live report is read on a phone (~375px), where the radius-120
// pie fell half off screen and the legend ran across it.
export const NARROW_PIE_WIDTH = 500

// Narrow: room for the pie itself, plus per legend item one line that may wrap
// to two (long answer options) at phone width.
const NARROW_PIE_HEIGHT = 240
const NARROW_LEGEND_ITEM_HEIGHT = 44

/**
 * @typedef {object} PieChartLayout
 * @property {boolean} narrow - True when the legend goes below the pie
 * @property {string} cx - Pie centre, horizontal
 * @property {number|string} outerRadius - Fixed px when wide, relative when narrow
 * @property {number} height - ResponsiveContainer height in px
 * @property {{layout: string, align: string, verticalAlign: string}} legend - Recharts Legend props
 */

/**
 * Layout for the pie charts with a side legend. Wide (or not yet measured) is
 * exactly the layout these charts always had, so desktop does not change.
 *
 * @param {number|null} width - Measured container width in px
 * @param {number} itemCount - Number of legend items
 * @returns {PieChartLayout}
 */
const pieChartLayout = (width, itemCount) => {
    const narrow = !!width && width < NARROW_PIE_WIDTH
    if (!narrow) {
        return {
            narrow: false,
            cx: '40%',
            outerRadius: 120,
            height: 300,
            legend: { layout: 'vertical', align: 'right', verticalAlign: 'middle' },
        }
    }
    return {
        narrow: true,
        cx: '50%',
        outerRadius: '90%',
        height: NARROW_PIE_HEIGHT + itemCount * NARROW_LEGEND_ITEM_HEIGHT,
        legend: { layout: 'vertical', align: 'center', verticalAlign: 'bottom' },
    }
}

export default pieChartLayout
